import { defineComponent, ref, onMounted, watch, computed } from "vue";
import Swal from "sweetalert2";
import EventBus from "@/EventBus";
import { ProductoService } from "@/services/ProductoService";
import { CarritoService } from "@/services/CarritoService";
import { useRoute, useRouter } from "vue-router"; // Importar useRoute para obtener los parámetros
import Header from "@/components/Header.vue";
import { config } from "@/config";
import { Search, SearchX } from 'lucide-vue-next';
import { formatCurrency } from "@/utils/formatPrice";
import { formatNumber } from "@/utils/formatNumber";
export default defineComponent({
    name: "ProductDetails",
    components: {
        Header,
        Search,
        SearchX
    },
    setup() {
        const route = useRoute();
        const router = useRouter();
        const productId = ref(null);
        const product = ref([]);
        const loading = ref(false);
        const productAdded = ref(false);
        const selectedImage = ref(null);
        const showCartAnimation = ref(false);
        const cartPosition = ref({ x: 0, y: 0 });
        // Estado del modal
        const isModalMiniaturaOpen = ref(false);
        const modalImageMiniatura = ref(null);
        const similarProducts = ref([]);
        const loadingSimilar = ref(false);
        const cartItems = ref([]);
        const isProcessing = ref(false);
        const animationProductId = ref(null);
        // --- NUEVO CÓDIGO PARA EL ZOOM DENTRO DEL MODAL ---
        const imageContainerRef = ref(null);
        const isZoomingInModal = ref(false);
        const mouseInModalX = ref(0);
        const mouseInModalY = ref(0);
        const handleMouseEnter = () => {
            isZoomingInModal.value = true;
        };
        const handleMouseLeave = () => {
            isZoomingInModal.value = false;
        };
        const handleMouseMove = (event) => {
            if (!imageContainerRef.value)
                return;
            const rect = imageContainerRef.value.getBoundingClientRect();
            mouseInModalX.value = event.clientX - rect.left;
            mouseInModalY.value = event.clientY - rect.top;
        };
        const imageZoomStyle = computed(() => {
            if (isZoomingInModal.value && imageContainerRef.value) {
                const originX = (mouseInModalX.value / imageContainerRef.value.offsetWidth) * 100;
                const originY = (mouseInModalY.value / imageContainerRef.value.offsetHeight) * 100;
                return {
                    transform: 'scale(2.5)', // Aumentamos un poco el zoom para que se note más
                    transformOrigin: `${originX}% ${originY}%`,
                    cursor: 'zoom-in',
                };
            }
            return {
                transform: 'scale(1)',
                transformOrigin: 'center center',
                cursor: 'default',
            };
        });
        // --- FIN DEL NUEVO CÓDIGO ---
        const item = ref({
            detalleCarritoID: 0,
            cantidad: 1, // Cantidad inicial de producto
        });
        const isLoggedIn = computed(() => {
            return localStorage.getItem("accessToken") !== null;
        });
        formatCurrency;
        // Función para convertir a formato título
        const toTitleCase = (str) => {
            if (!str)
                return '';
            return str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());
        };
        // Método para incrementar la cantidad
        const incrementQuantity = () => {
            item.value.cantidad += 1;
        };
        // Método para decrementar la cantidad
        const decrementQuantity = () => {
            item.value.cantidad -= 1;
        };
        // Método para obtener el producto por id
        const getProductoById = async (id) => {
            loading.value = true;
            try {
                const response = await ProductoService.getProductoById(id);
                console.log("esto", response.datos);
                product.value = response.datos;
                selectedImage.value = getImagenPortada(product.value.imagenes);
                // Supongamos que los productos similares se proporcionan en la respuesta
                // similarProducts.value = data.similares || [];
            }
            catch (error) {
                console.error("Error al cargar el producto:", error);
            }
            finally {
                loading.value = false;
            }
        };
        // Función para validar el token
        const isValidToken = () => {
            const token = localStorage.getItem("accessToken");
            return token && token.split(".").length === 3; // Verifica si el token tiene el formato adecuado
        };
        const isProductInCart = (productoId) => {
            const exists = cartItems.value.some(item => item.productoID === productoId);
            return exists;
        };
        const fetchCarritoUser = async () => {
            try {
                const datos = await CarritoService.getCarritoUser();
                // Validación de existencia de datos y detalles
                if (!datos || !datos.detallesCarrito) {
                    cartItems.value = []; // Reset visual del carrito
                    return;
                }
                // Todo en orden, asignamos al estado
                cartItems.value = datos.detallesCarrito;
            }
            catch (error) {
                Swal.fire({
                    title: "Error",
                    text: error?.message || "Error al obtener el carrito",
                    icon: "error",
                });
            }
        };
        // Método para agregar al carrito
        const agregarAlCarrito = async (productoId) => {
            let accessToken = localStorage.getItem("accessToken");
            if (!isValidToken()) {
                localStorage.removeItem("accessToken");
                accessToken = null;
            }
            if (!accessToken) {
                Swal.fire({
                    title: "Necesitas iniciar sesión",
                    text: "Para agregar productos al carrito, primero debes iniciar sesión.",
                    icon: "warning",
                    confirmButtonText: "Iniciar sesión",
                    customClass: { confirmButton: "swal-button--confirm-custom" },
                }).then((result) => {
                    if (result.isConfirmed)
                        router.push("/login");
                });
                return;
            }
            if (isProcessing.value)
                return;
            try {
                // Capturar la posición del botón de agregar al carrito
                const button = document.querySelector(".btn");
                if (button) {
                    const rect = button.getBoundingClientRect();
                    cartPosition.value = {
                        x: rect.left + rect.width / 2,
                        y: rect.top + rect.height / 2,
                    };
                }
                isProcessing.value = true;
                // Agregar el producto al carrito
                const response = await CarritoService.addDetalle({
                    productoID: productoId,
                    cantidad: item.value.cantidad,
                    detalleCarritoID: 0, // Valor temporal si es requerido
                    carritoID: 0, // Valor temporal si es requerido
                });
                if (response.exito) {
                    animationProductId.value = productoId;
                    setTimeout(() => {
                        showCartAnimation.value = true;
                        animationProductId.value = null;
                        isProcessing.value = false;
                        productAdded.value = true;
                        EventBus.emit("cartUpdated");
                    }, 2000);
                    showCartAnimation.value = false;
                    setTimeout(() => {
                        productAdded.value = false; // Restablece el mensaje después de un tiempo
                    }, 5000);
                }
                else {
                    isProcessing.value = false;
                    Swal.fire({
                        title: "Error",
                        text: `Error: ${response.errores}`,
                        icon: "error",
                    });
                }
            }
            catch (error) {
                isProcessing.value = false;
                console.error("Error al agregar el producto al carrito:", error);
                Swal.fire({
                    title: "Error",
                    text: "Error al agregar el producto al carrito",
                    icon: "error",
                });
            }
        };
        // Función para obtener la imagen de portada
        function getImagenPortada(imagenes) {
            if (Array.isArray(imagenes)) {
                // Buscar la imagen que tenga portada true
                const portada = imagenes.find((imagen) => imagen.portada);
                if (!portada)
                    return require("@/assets/paquete.png");
                return portada.imagen.startsWith('http') ? portada.imagen : `${config.API_URL}${portada.imagen}`;
            }
            // Si solo hay un objeto (sin ser array)
            if (!imagenes)
                return require("@/assets/paquete.png");
            return imagenes.imagen.startsWith('http') ? imagenes.imagen : `${config.API_URL}${imagenes.imagen}`;
        }
        // Función para cambiar la imagen principal
        const changeMainImage = (image) => {
            selectedImage.value = getImagenPortada(image); // Cambia la imagen principal cuando se selecciona una miniatura
        };
        // Abrir modal de imagen ampliada
        const ampliarImagenMiniatura = (imageUrl) => {
            modalImageMiniatura.value = imageUrl;
            isModalMiniaturaOpen.value = true;
        };
        // Cerrar modal
        const cerrarModalMiniatura = () => {
            isModalMiniaturaOpen.value = false;
        };
        const verDetallesProducto = (id) => {
            // Redirigir a la página de detalles pasando el `id` como parámetro
            router.push({ name: "ProductoDetalle", params: { id } });
        };
        // Método para obtener productos similares
        const getSimilarProducts = async () => {
            loadingSimilar.value = true;
            try {
                const response = await ProductoService.getAllProductos();
                // Filtra los productos similares según el criterio que prefieras
                similarProducts.value = response.datos.filter((p) => p.repuestoID === product.value.repuestoID && p.id !== product.value.id);
            }
            catch (error) {
                console.error("Error al cargar productos similares:", error);
            }
            finally {
                loadingSimilar.value = false; // <-- NUEVO: Termina la carga, sin importar el resultado
            }
        };
        watch(() => route.params.id, async (newId) => {
            if (newId) {
                productId.value = Number(newId);
                await getProductoById(productId.value);
            }
        });
        // Obtener el id del producto desde la URL
        onMounted(async () => {
            const id = route.params.id;
            if (id) {
                productId.value = Number(id);
                if (productId.value) {
                    // Esperamos a que el producto principal cargue para tener su ID
                    await getProductoById(productId.value);
                    // Ahora que ya cargó, buscamos el carrito y los similares
                    if (isLoggedIn.value) {
                        fetchCarritoUser();
                    }
                    getSimilarProducts(); // Ya no necesitamos esperar aquí, se encargará de su propio estado de carga
                }
            }
        });
        return {
            product,
            loading,
            isProcessing,
            item,
            productAdded,
            getImagenPortada,
            changeMainImage,
            selectedImage,
            agregarAlCarrito,
            incrementQuantity,
            decrementQuantity,
            showCartAnimation,
            cartPosition,
            verDetallesProducto,
            getSimilarProducts,
            loadingSimilar,
            similarProducts,
            formatCurrency,
            isLoggedIn,
            ampliarImagenMiniatura,
            cerrarModalMiniatura,
            isModalMiniaturaOpen,
            modalImageMiniatura,
            formatNumber,
            toTitleCase,
            animationProductId,
            isProductInCart,
            imageContainerRef,
            handleMouseEnter,
            handleMouseLeave,
            handleMouseMove,
            imageZoomStyle,
        };
    },
});
